import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bedding_quilts: FaireCategoryEntity = {
  token: "cat_bedding-quilts",
  type: "category",
  name: "Quilts & coverlets",
  level: 3,
  parentToken: "cat_home-decor-bedding",
  href: "/category/home-decor/bedding/quilts-coverlets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
